import { useState } from "react"
import { generateContent } from "../api/api"

export default function AIContent() {
  const [keyword, setKeyword] = useState("")
  const [type, setType] = useState("article")
  const [content, setContent] = useState("")
  const [loading, setLoading] = useState(false)

  async function generate() {
    setLoading(true)
    try {
      const res = await generateContent({ keyword, type })
      setContent(res.data.content)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page">
      <h1>AI Content Generator</h1>
      <div className="card form-row">
        <label>
          Keyword
          <input value={keyword} onChange={(e) => setKeyword(e.target.value)} />
        </label>
        <label>
          Type
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="article">Article</option>
            <option value="title">Title ideas</option>
            <option value="meta">Meta description</option>
          </select>
        </label>
        <button onClick={generate} disabled={loading}>
          {loading ? "Generating..." : "Generate"}
        </button>
      </div>
      {content && <pre>{content}</pre>}
    </div>
  )
}
